<template>
  <div class="right_body">		
     <slot></slot>
  </div>    
</template>
<script>
export default {
    
}
</script>